module.exports = __webpack_public_path__ + "static/img/1068_small.4fde87b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1068_small.png
// module id = wqo+
// module chunks = 1